<template lang="pug">
footer#v-footer
  | Copyright © 2019 流線傳媒有限公司 All rights reserved.
  |
  br(v-if='$store.state.mobile')
  a(href='https://buzzorange.com/techorange/', target='_blank') TechOrange科技報橘
  | ｜
  a(href='https://buzzorange.com/', target='_blank') BuzzOrange報橘
  | ｜
  a(href='https://buzzorange.com/vidaorange/', target='_blank') VidaOrange生活報橘
</template>

<script>
export default {
  name: 'Footer',
}
</script>

<style lang="sass" scoped>
@import '~@/mixin.sass'

#v-footer
  +font(14px, white, null, null, null, center)
  padding-bottom: 30px
  padding-top: 30px
  width: 100%

@media (max-width: 991px)
  #v-footer
    +font(12px, null, 18px)
    padding-bottom: 30px
    padding-top: 30px
    transform-origin: .5em 1em
    transform: scale(.75)
    width: 132%
</style>
